/* ============================================================
   TRAVERTIN NECHITUIT MARMOREX — product LP behaviour
   Vanilla ES6, no dependencies. Loaded once (defer) by the hero.
   init(root) is idempotent and re-runs on `shopify:section:load`
   so everything keeps working inside the Theme Editor.
   ============================================================ */
(function () {
  'use strict';

  // Mark JS active so CSS may hide reveal elements (they stay visible if JS never runs).
  document.documentElement.classList.add('tvn-js');

  /* ---------- tiny helpers ---------- */
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var clamp = function (n, lo, hi) { return Math.max(lo, Math.min(hi, n)); };
  var once = function (el) { if (!el || el.dataset.tvnInit === '1') return false; el.dataset.tvnInit = '1'; return true; };

  function ronFormat(value) {
    var rounded = Math.round(value * 100) / 100;
    var hasDec = Math.abs(rounded - Math.round(rounded)) > 0.001;
    return rounded.toLocaleString('ro-RO', {
      minimumFractionDigits: hasDec ? 2 : 0,
      maximumFractionDigits: 2
    }) + ' lei';
  }

  function ymd(d) {
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function parseYmd(s) {
    var p = (s || '').split('-');
    if (p.length !== 3) return null;
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }
  function daysBetween(fromStr, toStr) {
    var a = parseYmd(fromStr), b = parseYmd(toStr);
    if (!a || !b) return 0;
    return Math.max(0, Math.round((b - a) / 86400000));
  }

  /* ============================================================
     1. GALLERY  (main image swap + thumbnails + lightbox)
     ============================================================ */
  function initGallery(root) {
    $$('[data-tvn-gallery]', root).forEach(function (gal) {
      if (!once(gal)) return;
      var main = $('#tvn-main-image', gal) || $('.tvn-gallery__main img', gal);
      var thumbs = $$('.tvn-thumb[data-image]', gal);

      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-image');
          if (!src || !main) return;
          main.classList.add('is-fading');
          var img = new Image();
          img.onload = function () { main.src = src; main.classList.remove('is-fading'); };
          img.src = src;
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });

      // full-screen lightbox
      var images = thumbs.map(function (t) { return t.getAttribute('data-image'); }).filter(Boolean);
      var lb = $('#tvn-lightbox');
      var openBtn = $('[data-tvn-gallery-open]', gal);
      if (openBtn && lb && images.length) {
        var lbImg = $('.tvn-lightbox__img', lb);
        var idx = 0;
        var show = function (i) { idx = (i + images.length) % images.length; lbImg.src = images[idx]; };
        openBtn.addEventListener('click', function () {
          var cur = images.indexOf(main && main.src);
          show(cur > -1 ? cur : 0);
          openModal(lb);
        });
        var prev = $('[data-tvn-lightbox-prev]', lb), next = $('[data-tvn-lightbox-next]', lb);
        if (prev) prev.addEventListener('click', function () { show(idx - 1); });
        if (next) next.addEventListener('click', function () { show(idx + 1); });
      }
    });
  }

  /* ============================================================
     2. QUANTITY STEPPER
     ============================================================ */
  function initQty(root) {
    $$('[data-tvn-qty-wrap]', root).forEach(function (wrap) {
      if (!once(wrap)) return;
      var input = $('input', wrap);
      var minus = $('[data-tvn-qty="minus"]', wrap);
      var plus = $('[data-tvn-qty="plus"]', wrap);
      var step = parseFloat(input && input.step) || 1;
      var min = parseFloat(input && input.min) || 1;
      var clampVal = function () {
        var v = parseFloat(input.value);
        if (isNaN(v) || v < min) v = min;
        input.value = Number.isInteger(v) ? v : Math.round(v * 100) / 100;
      };
      if (minus) minus.addEventListener('click', function () { input.value = Math.max(min, (parseFloat(input.value) || min) - step); input.dispatchEvent(new Event('change', { bubbles: true })); });
      if (plus) plus.addEventListener('click', function () { input.value = (parseFloat(input.value) || 0) + step; input.dispatchEvent(new Event('change', { bubbles: true })); });
      if (input) input.addEventListener('change', clampVal);
    });
  }

  /* ============================================================
     3. M² CALCULATOR
     ============================================================ */
  function initCalculator(root) {
    $$('[data-tvn-calc]', root).forEach(function (calc) {
      if (!once(calc)) return;
      var L = $('#tvn-calc-l', calc), W = $('#tvn-calc-w', calc), waste = $('#tvn-calc-waste', calc);
      var outArea = $('#tvn-calc-area', calc), outTotal = $('#tvn-calc-total', calc);
      var useBtn = $('[data-tvn-calc-use]', calc);
      var priceCents = parseFloat(calc.getAttribute('data-price-cents')) || (window.__tvn && window.__tvn.priceCents) || 0;
      var pricePerM2 = priceCents / 100;

      function compute() {
        var l = parseFloat(L && L.value) || 0;
        var w = parseFloat(W && W.value) || 0;
        var area = l * w;
        if (waste && waste.checked) area *= 1.10;
        var total = area * pricePerM2;
        if (outArea) outArea.textContent = area > 0 ? (Math.round(area * 100) / 100).toLocaleString('ro-RO') + ' m²' : '0 m²';
        if (outTotal) outTotal.textContent = total > 0 ? ronFormat(total) : '0 lei';
        calc._area = area;
      }
      [L, W].forEach(function (el) { if (el) el.addEventListener('input', compute); });
      if (waste) waste.addEventListener('change', compute);
      if (useBtn) useBtn.addEventListener('click', function () {
        var qty = Math.max(1, Math.ceil(calc._area || 0));
        var target = $('#tvn-qty');
        if (target) { target.value = qty; target.dispatchEvent(new Event('change', { bubbles: true })); }
        toast('Cantitate setată: ' + qty + ' m²');
        var bb = $('#tvn-buybox'); if (bb) bb.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      compute();
    });
  }

  /* ============================================================
     4. LIVE STOCK BAR  (per-user, persisted in localStorage)
     ============================================================ */
  function initStock(root) {
    $$('[data-tvn-stock]', root).forEach(function (el) {
      if (!once(el)) return;
      var rawStart = parseFloat(el.getAttribute('data-start-pct'));
      var startPct = clamp(isNaN(rawStart) ? 35 : rawStart, 0, 100); // 0 este o valoare validă (stoc epuizat)
      var rawFloor = parseFloat(el.getAttribute('data-floor'));
      var floor = clamp(isNaN(rawFloor) ? 8 : rawFloor, 0, 100);
      var startDate = el.getAttribute('data-start-date');
      var fill = $('.tvn-stock__fill', el), pctEl = $('.tvn-stock__pct', el), label = $('[data-tvn-stock-label]', el);
      var KEY = 'tvn_stock_pct', DKEY = 'tvn_stock_date', AKEY = 'tvn_stock_anchor';
      var todayStr = ymd(new Date());
      var pct, store;
      try { store = window.localStorage; } catch (e) { store = null; }

      var anchor = (startDate || '') + '|' + startPct + '|' + floor;
      var decay = function (p, days) { for (var i = 0; i < days; i++) { p -= 1 + Math.floor(Math.random() * 2); } return p; };

      if (!store) {
        pct = Math.max(floor, Math.round(decay(startPct, startDate ? daysBetween(startDate, todayStr) : 0)));
      } else if (store.getItem(AKEY) !== anchor) {
        // config changed (or first visit) → seed from the start date
        pct = Math.max(floor, Math.round(decay(startPct, startDate ? daysBetween(startDate, todayStr) : 0)));
        store.setItem(AKEY, anchor); store.setItem(KEY, pct); store.setItem(DKEY, todayStr);
      } else {
        pct = parseFloat(store.getItem(KEY));
        if (isNaN(pct)) pct = startPct;
        var elapsed = daysBetween(store.getItem(DKEY) || todayStr, todayStr);
        if (elapsed > 0) { pct = Math.max(floor, Math.round(decay(pct, elapsed))); store.setItem(KEY, pct); store.setItem(DKEY, todayStr); }
      }
      pct = clamp(pct, floor, 100);

      if (pctEl) pctEl.textContent = pct + '%';
      if (label && label.getAttribute('data-tpl')) label.textContent = label.getAttribute('data-tpl').replace('{pct}', pct);
      // animate fill once it scrolls into view
      var draw = function () { if (fill) fill.style.width = pct + '%'; };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { requestAnimationFrame(draw); io.disconnect(); } });
        }, { threshold: 0.3 });
        io.observe(el);
      } else { draw(); }
    });
  }

  /* ============================================================
     5. ADD TO CART  (Shopify AJAX API)
     ============================================================ */
  function cartAdd(variantId, qty) {
    var payload = { id: Number(variantId), quantity: qty };
    // Mod PRECOMANDĂ: dacă pagina a setat o notă de precomandă (ex. popup-ul
    // tvn-precomanda-popup), fiecare linie de comandă primește eticheta,
    // vizibilă în admin, la checkout și pe emailul de confirmare.
    if (window.__tvn && window.__tvn.preorderNote) {
      payload.properties = { 'Livrare': window.__tvn.preorderNote };
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Eroare la adăugare'); });
      return r.json();
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('.cart-count, .cart-count-bubble, [data-cart-count], cart-bubble .count, .header__cart-count').forEach(function (n) {
          n.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        // best-effort: open the theme cart drawer if present
        var drawer = document.querySelector('cart-drawer, cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
      }).catch(function () {});
  }

  function initAddToCart(root) {
    $$('[data-tvn-add]', root).forEach(function (btn) {
      if (!once(btn)) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-variant-id') || (window.__tvn && window.__tvn.variantId);
        if (!variantId) { toast('Produs indisponibil'); return; }
        var qtySel = btn.getAttribute('data-qty-from');
        var qtyEl = qtySel ? $(qtySel) : $('#tvn-qty');
        var qty = Math.max(1, Math.floor(parseFloat(qtyEl && qtyEl.value) || 1));
        var label = btn.innerHTML;
        btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Se adaugă…';
        cartAdd(variantId, qty).then(function () {
          // redirect straight to the cart after adding
          window.location.href = '/cart';
        }).catch(function (err) {
          btn.innerHTML = label; btn.disabled = false;
          toast(err.message || 'Eroare la adăugare');
        });
      });
    });
  }

  /* ============================================================
     6. MINI REVIEW ROTATOR (hero)
     ============================================================ */
  function initMiniReviews(root) {
    $$('[data-tvn-minirev]', root).forEach(function (box) {
      if (!once(box)) return;
      var items = $$('.tvn-minirev__item', box);
      // dots container is a sibling of the box (inside the same card), so search the parent too
      var dotsWrap = $('[data-tvn-minirev-dots]', box.parentNode) || $('[data-tvn-minirev-dots]', box);
      if (items.length < 2) return;
      var i = 0, timer;
      var dots = items.map(function (_, k) {
        var d = document.createElement('button');
        d.className = 'tvn-dot' + (k === 0 ? ' is-active' : '');
        d.type = 'button'; d.setAttribute('aria-label', 'Recenzia ' + (k + 1));
        d.addEventListener('click', function () { go(k); reset(); });
        if (dotsWrap) dotsWrap.appendChild(d);
        return d;
      });
      function go(n) {
        items[i].classList.remove('is-active'); dots[i].classList.remove('is-active');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active'); dots[i].classList.add('is-active');
      }
      function tick() { go(i + 1); }
      function start() { timer = setInterval(tick, 5000); }
      function reset() { clearInterval(timer); start(); }
      box.addEventListener('mouseenter', function () { clearInterval(timer); });
      box.addEventListener('mouseleave', start);
      start();
    });
  }

  /* ============================================================
     7. CAROUSELS (reviews / experts / projects)
     ============================================================ */
  function initCarousels(root) {
    $$('[data-tvn-carousel]', root).forEach(function (car) {
      if (!once(car)) return;
      var track = $('.tvn-carousel__track', car);
      var prev = $('[data-tvn-carousel-prev]', car), next = $('[data-tvn-carousel-next]', car);
      var dotsWrap = $('[data-tvn-carousel-dots]', car);
      if (!track) return;

      var page = function () { return Math.max(track.clientWidth * 0.9, 240); };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: 'smooth' }); });

      var dots = [];
      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        var pages = Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth));
        dots = [];
        for (var p = 0; p < pages; p++) {
          (function (p) {
            var d = document.createElement('button');
            d.className = 'tvn-dot'; d.type = 'button'; d.setAttribute('aria-label', 'Pagina ' + (p + 1));
            d.addEventListener('click', function () { track.scrollTo({ left: p * track.clientWidth, behavior: 'smooth' }); });
            dotsWrap.appendChild(d); dots.push(d);
          })(p);
        }
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        if (dots.length) {
          var active = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (d, k) { d.classList.toggle('is-active', k === active); });
        }
      }
      buildDots(); sync();
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', function () { buildDots(); sync(); });
    });
  }

  /* ============================================================
     8. FAQ ACCORDION (single-open, animated)
     ============================================================ */
  function initAccordion(root) {
    $$('[data-tvn-accordion]', root).forEach(function (acc) {
      if (!once(acc)) return;
      var items = $$('.tvn-faq__item', acc);
      items.forEach(function (item) {
        var q = $('.tvn-faq__q', item), a = $('.tvn-faq__a', item);
        if (!q || !a) return;
        q.setAttribute('aria-expanded', 'false');
        q.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          items.forEach(function (other) {
            if (other === item) return;
            other.classList.remove('is-open');
            var oa = $('.tvn-faq__a', other), oq = $('.tvn-faq__q', other);
            if (oa) oa.style.height = '0px';
            if (oq) oq.setAttribute('aria-expanded', 'false');
          });
          if (open) { item.classList.remove('is-open'); a.style.height = '0px'; q.setAttribute('aria-expanded', 'false'); }
          else { item.classList.add('is-open'); a.style.height = a.scrollHeight + 'px'; q.setAttribute('aria-expanded', 'true'); }
        });
      });
      window.addEventListener('resize', function () {
        var open = $('.tvn-faq__item.is-open .tvn-faq__a', acc);
        if (open) open.style.height = open.scrollHeight + 'px';
      });
    });
  }

  /* ============================================================
     9. MOBILE STICKY BAR (shows after the buy box scrolls away)
     ============================================================ */
  function initMobileBar(root) {
    var bar = $('#tvn-mobilebar', root) || $('#tvn-mobilebar');
    var anchor = $('#tvn-buybox');
    if (!bar || !anchor || !once(bar)) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }, { threshold: 0 });
      io.observe(anchor);
    }
  }

  /* ============================================================
     10. "REQUEST REAL STOCK PHOTOS" MODAL → WhatsApp
     ============================================================ */
  function openModal(m) { if (!m) return; m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  function closeModal(m) { if (!m) return; m.classList.remove('is-open'); document.documentElement.style.overflow = ''; }

  function initModals(root) {
    $$('[data-tvn-modal]', root).forEach(function (m) {
      if (!once(m)) return;
      $$('[data-tvn-modal-close], .tvn-modal__overlay', m).forEach(function (c) {
        c.addEventListener('click', function () { closeModal(m); });
      });
      var send = $('[data-tvn-wa-send]', m);
      if (send) send.addEventListener('click', function () {
        var num = m.getAttribute('data-wa-number') || '';
        var product = m.getAttribute('data-product') || '';
        var name = (($('[name="tvn-name"]', m) || {}).value || '').trim();
        var phone = (($('[name="tvn-phone"]', m) || {}).value || '').trim();
        var area = (($('[name="tvn-area"]', m) || {}).value || '').trim();
        var msg = 'Bună ziua! Aș dori poze reale cu stocul pentru ' + product + '.';
        if (name) msg += '\nNume: ' + name;
        if (phone) msg += '\nTelefon: ' + phone;
        if (area) msg += '\nSuprafață estimată: ' + area + ' m²';
        window.open('https://wa.me/' + num + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
        closeModal(m);
      });
    });
    $$('[data-tvn-modal-open]', root).forEach(function (btn) {
      if (!once(btn)) return;
      btn.addEventListener('click', function (e) { e.preventDefault(); openModal($('#' + btn.getAttribute('data-tvn-modal-open'))); });
    });
    if (!document._tvnEsc) {
      document._tvnEsc = true;
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.tvn-modal.is-open').forEach(closeModal); });
    }
  }

  /* ============================================================
     11. SMOOTH SCROLL  (CTA buttons → hero buy box)
     ============================================================ */
  function initScrollLinks(root) {
    $$('[data-tvn-scroll]', root).forEach(function (btn) {
      if (!once(btn)) return;
      btn.addEventListener('click', function (e) {
        var target = $(btn.getAttribute('data-tvn-scroll'));
        if (!target) return;
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  /* ============================================================
     12. REVEAL ON SCROLL  +  SVG CONNECTOR DRAW
     ============================================================ */
  function initReveal(root) {
    var targets = $$('.tvn-reveal', root).filter(once);
    var connectors = $$('.tvn-connector', root).filter(function (c) { return c.dataset.tvnConn !== '1'; });
    connectors.forEach(function (c) {
      c.dataset.tvnConn = '1';
      var p = $('path', c);
      if (p && p.getTotalLength) { var len = Math.ceil(p.getTotalLength()); c.style.setProperty('--len', len); }
    });
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-in'); });
      connectors.forEach(function (c) { c.classList.add('is-drawn'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in', 'is-drawn');
        io.unobserve(en.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    targets.concat(connectors).forEach(function (t) { io.observe(t); });
  }

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(html, isHtml) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'tvn-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<i class="fas fa-check-circle"></i><span>' + (isHtml ? html : escapeHtml(html)) + '</span>';
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 4200);
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  /* ---------- buy box price context ---------- */
  function initBuybox(root) {
    var bb = $('#tvn-buybox', root) || $('#tvn-buybox');
    if (bb) {
      window.__tvn = window.__tvn || {};
      window.__tvn.variantId = bb.getAttribute('data-variant-id') || window.__tvn.variantId;
      window.__tvn.priceCents = parseFloat(bb.getAttribute('data-price-cents')) || window.__tvn.priceCents;
    }
  }

  /* ---------- master init ---------- */
  function init(root) {
    root = root || document;
    // Each step is isolated so one failure can never block the others (esp. reveal).
    [initBuybox, initGallery, initQty, initCalculator, initStock, initAddToCart,
     initMiniReviews, initCarousels, initAccordion, initMobileBar, initModals,
     initScrollLinks, initReveal].forEach(function (fn) {
      try { fn(root); } catch (e) { if (window.console) console.warn('[tvn]', fn.name, e); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // Theme Editor: re-init the section that just (re)loaded
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
